<script lang="ts">
  import MetaData from "$lib/MetaData.svelte";
  import CoverPicture from "$lib/CoverPicture.svelte";
  import Lead from "$lib/Lead.svelte";
  import type { PortableTextBlock } from "@portabletext/types";
  import PortableTextContent from "$lib/portableText/PortableTextContent.svelte";
  import type { ImageWithMeta } from "./types/shared";

  interface Props {
    data?:
      | {
          title?: string;
          description?: string;
          author?: string;
          image?: string;
          imageAlt?: string;
          keywords?: string[];
          twitter?: string;
          type?: string;
          canonical?: string;
          datePublished?: string;
        }
      | undefined;
    image?: ImageWithMeta | null;
    portableText?: PortableTextBlock[] | null;
    imageAsCover?: boolean;
    descriptionAsLead?: boolean;
    // which html child level should margins be applied to? TODO: make able to disable
    contentNestingLevel?: 1 | 2 | null;
    jsonLd?: boolean;
    h1?: string | null;
    class?: string;
    cover?: import("svelte").Snippet;
    children?: import("svelte").Snippet;
  }

  let {
    data = undefined,
    image = null,
    portableText = null,
    imageAsCover = false,
    descriptionAsLead = true,
    contentNestingLevel = 1,
    jsonLd = false,
    h1 = null,
    class: classes = "",
    cover,
    children,
  }: Props = $props();
</script>

<MetaData {data} {jsonLd} />

<article
  class={`page-component-article ${classes} ${contentNestingLevel ? `page-component-content-nesting-level-${contentNestingLevel}` : ``}`}
>
  {@render cover?.()}

  {#if !cover && imageAsCover && image}
    <CoverPicture {image}>
      <h1 class="text-h-hero text-pretty">{h1 || data?.title}</h1>
    </CoverPicture>
  {:else if !cover}
    <h1 class="mx-edge-x my-10 text-h-hero text-pretty">{h1 || data?.title}</h1>
  {/if}

  {#if descriptionAsLead && data?.description}
    <Lead>{data?.description}</Lead>
  {/if}

  {@render children?.()}

  {#if portableText}
    <PortableTextContent content={portableText} --line-height="1.5" />
  {/if}
</article>

<style lang="postcss">
  :where(:global(.page-component-article)) {
    font-size: var(--text-body);
  }

  :global(:where(.page-component-content-nesting-level-1)) > :global(:where(*)) {
    margin-inline: var(--space-edge-x);
  }

  :global(:where(.page-component-content-nesting-level-2))
    > :global(:where(*))
    > :global(:where(*)) {
    margin-inline: var(--space-edge-x);
  }

  :where(:global(.page-component-article)) :global(:where(p)) {
    max-width: var(--max-w, var(--w-prose));
  }
</style>
